import gql from "graphql-tag";

export const CREATE_BRAND = gql`
  mutation AddBrand($data: BrandDataInput) {
    addBrand(data: $data) {
      id
    }
  }
`;

export const UPDATE_BRAND = gql`
  mutation UpdateBrand($data: BrandDataInput, $where: BrandWhereInput) {
    updateBrand(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_BRAND = gql`
  mutation DeleteBrand($where: BrandWhereInput) {
    deleteBrand(where: $where) {
      id
    }
  }
`;

export const IMPORT_BRANDS_FROM_EXCEL = gql`
  mutation ImportBrandsFromExcel($data: UploadDocument) {
    importBrandsFromExcel(data: $data) {
      success
      brandsCreated
      modelsCreated
      modelsUpdated
      modelsSkipped
      totalRows
      errors {
        row
        message
      }
    }
  }
`;

const brands = {
  CREATE_BRAND,
  UPDATE_BRAND,
  DELETE_BRAND,
  IMPORT_BRANDS_FROM_EXCEL,
};

export default brands;
